







import { createComponent } from "@vue/composition-api";

interface BaseImageOption {
  label: string;
}

export default createComponent({
  props: {
    label: {
      type: String,
      required: true
    }
  },
  setup(props: Readonly<BaseImageOption>, context) {}
});
